import {URL_CONFIG} from '@/url_config';
import store from "@/store";

const BASE_URL = URL_CONFIG.mi_url
const PRO_FILE_URL = `${BASE_URL}/mi_ai/project_file`;


export const getFileInfoByKeySvrUrl = (projectId, fileKey, rootKey, file_hash) => {
    return `${PRO_FILE_URL}/get_file_by_key?project_id=${projectId}&file_key=${fileKey}&root_key=${rootKey}&file_hash=${file_hash}`
}

const handleResponse = async (response) => {
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP Error ${response.status}: ${errorText}`);
    }
    return response.json();
};

export const createProjectFileBatch = async (project_id, root_key, ProjectFileList) => {
    const response = await fetch(`${PRO_FILE_URL}/batch`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({"project_id": project_id, "root_key": root_key, "file_list":ProjectFileList}),
    });
    return handleResponse(response);
};

export const getProjectFiles = async (projectId) => {
    const url = new URL(`${PRO_FILE_URL}/get_files?project_id=${projectId}`);

    const response = await fetch(url.toString(), { method: 'GET' });
    return handleResponse(response);
};

export const getProjects = async (start_time, end_time, skip, limit, search_id, excludeList) => {
    const url = new URL(`${PRO_FILE_URL}/get_projects?start_time=${start_time}&end_time=${end_time}&skip=${skip}&limit=${limit}&project_id=${search_id}&exclude_project_ids=${excludeList}`);

    const response = await fetch(url.toString(), { method: 'GET' });
    return handleResponse(response);
};
